import { Grid } from "@material-ui/core";
import { Field } from "formik";
import * as React from "react";
import { t } from "../../i18n/util";
import { CustomInputField } from "../ui/CustomInputField";
import { THEME } from "../../theme/ThemeStore";
import { CustomAutoComplete } from "../ui/CustomAutoComplete";
import { useUsers } from "../hooks/useUsers";
import { CustomCheckbox } from "../ui/CustomCheckbox";
import { SelectedUsersList } from "./SelectedUsersList";

export const JobCategoryEditDetailsGrid = ({ values, setFieldValue }: { values: any; setFieldValue: (field: string, value: any) => void }) => {
    const users = useUsers()?.map((user) => user.username);

    const handleTogglePrimary = (user: string) => {
        const isCurrentlyPrimary = values.primaryContactEmails.includes(user);
        if (isCurrentlyPrimary) {
            const updatedPrimaryContacts = values.primaryContactEmails.filter((u: string) => u !== user);
            setFieldValue("primaryContactEmails", updatedPrimaryContacts);
        } else {
            setFieldValue("primaryContactEmails", [...values.primaryContactEmails, user]);
        }
    };

    return (
        <Grid style={{ display: "flex", flexDirection: "column", gap: 16 }}>
            <Field
                component={CustomInputField}
                label={t("screen.jobcategories.name")}
                name="name"
                required
            />
            <div
                style={{
                    display: "flex",
                    alignItems: "center",
                    gap: 10,
                    color: THEME.customColors.headingsDark
                }}
                className="body1"
            >
                <Field
                    type="checkbox"
                    name="isActive"
                    component={CustomCheckbox}
                />
                {t("screen.jobcategory.active")}
            </div>
            <Field
                component={CustomAutoComplete}
                options={users?.filter((u) => !values.notificationUserEmails?.includes(u)) ?? []}
                placeholder={t("screen.jobcategory.addContacts")}
                name="notificationUserEmails"
                setFieldValue={setFieldValue}
                style={{ width: "100%" }}
                value={values.notificationUserEmails}
            />
            <SelectedUsersList
                selectedUsers={values.notificationUserEmails || []}
                primaryContactIds={values.primaryContactEmails || []}
                onTogglePrimary={handleTogglePrimary}
            />
        </Grid>
    );
};
